import React from 'react';
import cx from 'classnames';

import { IconProps } from '../../interfaces/icon';

import styles from './Icon.module.scss';

export default function Icon (props: IconProps) {
  const {
    id,
    name,
    type = 'line',
    className,
    theme = 'dark',
  } = props;

  const isDarkTheme = theme === 'dark';
  // if icon has not available fill or line types, send none to do not concat the type
  const iconName = type === 'none' ? `ri-${name}` : `ri-${name}-${type}`;

  return <i
    id={id}
    className={cx(iconName, styles.lrvIcon, isDarkTheme ? styles.iconDark : styles.iconLight, className)}
  />;
}
